export default (namespace) => ({
  [`${namespace}.firstTitle`]: '¿Cómo es tú teléfono?',
  [`${namespace}.secondTitle`]: 'Elige tus coberturas',
});
